import { motion } from "framer-motion";
import { BRANDS } from "@/data/hvm";

export const Marquee = () => {
  return (
    <div data-testid="brands-strip" className="relative border-y border-[#26334D] bg-[#0E1420]">
      <div className="max-w-7xl mx-auto flex flex-wrap items-stretch justify-center">
        <div className="hidden lg:flex items-center px-6 border-r border-[#26334D]">
          <p className="font-tech text-[10px] tracking-[0.3em] uppercase text-[#F4A031] leading-relaxed">
            Specified from<br />six leading brands
          </p>
        </div>
        {BRANDS.map((b, i) => (
          <motion.div
            key={b.name}
            data-testid={`brand-badge-${i}`}
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.07, duration: 0.5 }}
            className="group px-4 py-6 text-center hover:bg-[#131927] transition-colors"
          >
            <div className="inline-flex items-center justify-center bg-[#0B0F17] border border-[#26334D] rounded-md px-3 h-12 transition-colors group-hover:border-[#F4A031]">
              <img src={b.logo} alt={`${b.name} logo`} width="130" height="28" className="max-h-7 max-w-[118px] object-contain" />
            </div>
            {b.origin && (
              <p className="font-tech text-[10px] tracking-[0.2em] uppercase text-[#64748B] mt-2.5">
                {b.origin}
              </p>
            )}
          </motion.div>
        ))}
      </div>
    </div>
  );
};
